import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '@app/auth/auth.service';
import { PUBLIC_ROUTES } from '../constants/app.constants';
import { UserRole } from '../constants/roles.enum';

/** Restricts a route to delivery couriers (REPARTO). */
export const CourierGuard: CanActivateFn = () => {
  const auth = inject(AuthService);
  const router = inject(Router);

  if (!auth.isUserLoggedIn()) {
    return router.createUrlTree([`/${PUBLIC_ROUTES.login}`]);
  }
  if (auth.getDecodedToken().role !== UserRole.REPARTO) {
    return router.createUrlTree([auth.homeRoute()]);
  }
  return true;
};
